export const DATE_RANGE_OPTIONS = {
	THIS_WEEK: 'This Week',
	THIS_MONTH: 'This Month',
	LAST_WEEK: 'Last Week',
	LAST_MONTH: 'Last Month',
	CUSTOM_DATES: 'Custom Dates',
}
export const APPLY_TEXT = 'Apply';
export const CANCEL_TEXT = 'Cancel';
